export enum UserRole {
  Admin = 'Admin',
  User = 'User',
}

export enum BaseStationType {
  Sigfox = 1,
}

export enum ProductType {
  RIC1010 = 'RIC1010',
  RIC1020 = 'RIC1020',
  RIC1030 = 'RIC1030',
}

export enum NotificationType {
  Sms = 'Sms',
  Email = 'Email',
}

export enum EventType {
  Low = 'Low',
  High = 'High',
}

export enum SensorType {
  None = 'None',
  AgriDrain800770 = 'AgriDrain800770',
  AquaTroll500DissolvedOxygenSensor = 'AquaTroll500DissolvedOxygenSensor',
  AquaTroll500NitrateSensor = 'AquaTroll500NitrateSensor',
  AquaTroll500SalinitySensor = 'AquaTroll500SalinitySensor',
  AquaTroll500SpecificConductivitySensor = 'AquaTroll500SpecificConductivitySensor',
  AquaTroll500TemperatureSensor = 'AquaTroll500TemperatureSensor',
  AquaTroll500TotalDissolvedSolidsSensor = 'AquaTroll500TotalDissolvedSolidsSensor',
  AquaTroll500TurbiditySensor = 'AquaTroll500TurbiditySensor',
  Badgermeter220BR = 'Badgermeter220BR',
  BadgermeterSDI = 'BadgermeterSDI',
  Battery = 'Battery',
  DEMPaddleWheel = 'DEMPaddleWheel',
  Dwyer628 = 'Dwyer628',
  Humidity = 'Humidity',
  IrrometerWM200SS = 'IrrometerWM200SS',
  Pressure = 'Pressure',
  Rainfall = 'Rainfall',
  SolarRadiation = 'SolarRadiation',
  SwitchNormallyClosed = 'SwitchNormallyClosed ',
  SwitchNormallyOpen = 'SwitchNormallyOpen',
  Temperature = 'Temperature',
  Unknown = 'Unknown',
  VegetronixVH400 = 'VegetronixVH400',
  WindDirection = 'WindDirection',
  WindSpeed = 'WindSpeed',
  CountButtonCB100 = 'CountButtonCB100',
  ServiceButtonSB100 = 'ServiceButtonSB100',
  TiltSensorTS100 = 'TiltSensorTS100',
}

export enum UnitCategory {
  Unknown = 'Unknown',
  Volume = 'Volume',
  VolumeRate = 'VolumeRate',
  Temperature = 'Temperature',
  VolumetricWaterContent = 'VolumetricWaterContent',
  VolumePulse = 'VolumePulse',
  DepthHeightDistance = 'DepthHeightDistance',
  Pressure = 'Pressure',
  ElectricPotentialDifference = 'ElectricPotentialDifference',
  SwitchContact = 'SwitchContact',
  TotalVolume = 'TotalVolume',
  PressureGauge = 'PressureGauge',
  WindDirection = 'WindDirection',
  WindSpeed = 'WindSpeed',
  Rainfall = 'Rainfall',
  SolarRadiation = 'SolarRadiation',
  Humidity = 'Humidity',
  WindDistribution = 'WindDistribution',
  RainfallRate = 'RainfallRate',
}

// export enum UnitCategory {
//   Volume = 'Vol',
//   VolumeRate = 'VRate',
//   Temperature = 'Temp',
//   VolumetricWaterContent = 'VWC',
//   VolumePulse = 'VPulse',
//   DepthHeightDistance = 'Depth',
//   Pressure = 'Pres',
//   ElectricPotentialDifference = 'EPD',
//   SwitchContact = 'Switch',
//   TotalVolume = 'TVol',
//   PressureGauge = 'PresG',
//   WindDirection = 'WDir',
//   WindSpeed = 'WSpd',
//   Rainfall = 'Rain',
//   SolarRadiation = 'SolRad',
//   Humidity = 'HMD',
//   WindDistribution = 'WDst',
//   RainfallRate = 'RRate',
// }

export enum BaseUnits {
  Volume = 'cubic meters',
  VolumeRate = 'cubic meters / seconds',
  Temperature = 'celsius',
  VolumetricWaterContent = 'percent',
  VolumePulse = 'cubic meters',
  DepthHeightDistance = 'meter',
  Pressure = 'pascals',
  ElectricPotentialDifference = 'volts',
  SwitchContact = 'percent',
  TotalVolume = 'cubic meters',
  PressureGauge = 'pascals',
  WindDirection = 'pounds / square inch',
  WindSpeed = 'meters / second',
  Rainfall = 'meters',
  SolarRadiation = 'watts / square meter',
  Humidity = 'percent',
  WindDistribution = 'percent',
  RainfallRate = 'millimeters / minute',
  DissolvedOxygen = 'milligrams / liter',
  Turbidity = 'NTU',
  TotalDissolvedSolids = 'parts per million',
  Nitrates = 'milligrams / liter',
  SpecificConductivity = 'microsimoles / centimeter',
  Salinity = 'practical salinity unit',
  Count = 'count',

  // special cases
  Battery = 'voltage',
  Message = 'message',

  Unknown = 'unknown',
}

export enum SensorPort {
  A1 = 'A1',
  A2 = 'A2',

  B1 = 'B1',
  B2 = 'B2',

  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',

  Unknown = 'Unknown',
}

export enum SoilType {
  Sand = 'Sand',
  LoamySand = 'LoamySand',
  SandyLoam = 'SandyLoam',
  Loam = 'Loam',
  SiltLoam = 'SiltLoam',
  Silt = 'Silt',
  SandyClayLoam = 'SandyClayLoam',
  SiltyClayLoam = 'SiltyClayLoam',
  SiltyClay = 'SiltyClay',
  Clay = 'Clay',
}

export enum SigfoxMessageType {
  TestMessage = 0x04,
  SeqNumTimestamp = 0x05,
  ScheduledReading = 0x06,
  DeviceConfig1 = 0x07,
  DeviceConfig2 = 0x08,
  DeviceConfig3 = 0x09,
  DeviceConfig4 = 0x0a,
  DeviceConfig5 = 0x0b,
  SensorConfig1 = 0x0c,
}

export enum CoordinateType {
  NotSet = 'NotSet',
  LatLong = 'LatLong',
  UTM = 'UTM',
  MGRS = 'MGRS',
}

export enum DeviceMode {
  Standard = 'Standard',
  WeatherStation = 'Weather Station',
  WaterQuality = 'Water Quality',
  DirtTracker = 'Dirt Tracker',
  Unknown = 'Unknown',
}
